import {
  CompanyOverviewDto,
  EmployeesReportView,
  EnrollmentStatus,
} from '@zorro/clients';
import { Card } from '@zorro/design-system/v2/Card';
import { Box, Grid, Group, Space, Text } from '@zorro/web/design-system';

import { EnrollmentStatusIconTooltip } from '../EnrollmentStatus/EnrollmentStatusIconTooltip';
import { getEnrollmentStatusView } from '../EnrollmentStatus/EnrollmentStatusUtils';
import classNames from './CompanyCoverageOverview.module.scss';

type Props = {
  eligibleEmployeesCount: number;
  currentCoverageCountByStatus: CompanyOverviewDto['currentCoverageCountByStatus'];
  enrollmentYear: number | null;
  onClick: (
    status: EnrollmentStatus,
    year?: number,
    params?: Record<string, string>
  ) => void;
};

const coverageIcons = [
  EnrollmentStatus.ACTIVE_COVERAGE,
  EnrollmentStatus.WAIVED_COVERAGE,
  EnrollmentStatus.COVERAGE_ENDED,
];

export const CompanyCoverageOverview = ({
  eligibleEmployeesCount,
  currentCoverageCountByStatus,
  enrollmentYear,
  onClick,
}: Props) => {
  return (
    <Box>
      <Text fw={600} size="md">
        Current coverage
        <Text c="zorroGray.4" ml="xs">
          {eligibleEmployeesCount} currently eligible
        </Text>
      </Text>
      <Space h="md" />
      <Grid>
        {coverageIcons.map((enrollmentStatus) => (
          <Grid.Col key={enrollmentStatus} span={4}>
            <Card
              variant="white-border"
              radius="md"
              onClick={() =>
                onClick(enrollmentStatus, enrollmentYear || undefined, {
                  view: EmployeesReportView.LATEST_COVERAGE,
                })
              }
              className={classNames.root}
            >
              <Group mb="lg" justify="space-between" align="center">
                <Text size="24px" fw="bold">
                  {currentCoverageCountByStatus[enrollmentStatus] || 0}
                </Text>
                <EnrollmentStatusIconTooltip
                  enrollmentStatus={enrollmentStatus}
                />
              </Group>
              <Text size="md">
                {getEnrollmentStatusView(enrollmentStatus).label}
              </Text>
            </Card>
          </Grid.Col>
        ))}
      </Grid>
    </Box>
  );
};
